<template>
   <div id="uploadFiles" class="d-flex">
    <MainBarMenuV2 />
     <div class="header-top">
       <div class="container-fluid">
         <HeadingUser />
       </div>
     </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row-center mt-5">
          <div class="col-xs-12 col-md-8 mx-auto mt-5 drop-container">
            <div class="d-flex align-items-md-center flex-md-row flex-sm-column">
                <div class="col-sm-12 col-md-6">
                    <div class="d-flex align-items-center mb-4">
                        <img class="mr-3"  src="@/assets/images/icons/list_alt.svg" width="20px"> <h3 class="m-0">Base de datos maestros</h3>
                    </div>
                    <p>Archivo plano que contiene toda la base de datos de los empleados pertenecientes a la compañía y sus diferentes razones sociales <strong>Solo se permiten archivos .csv</strong></p>
                    <p><a :href="templateEmployee" target="_blank">Descargar plantilla</a></p>
                </div>
                <div class="col-sm-12 col-md-6 mt-sm-3">
                    <div class="file-upload-img col-12">
                        <input
                        type="file"
                        id="fileDocuEmployees"
                        @change="fileSelected('employees')"
                        accept=".csv"
                        required
                        />
                        <span>
                        <img class="col-12" src="@/assets/images/settler/uploadFile.jpg" />
                        </span>
                    </div>
                </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8 mx-auto mt-5 drop-container">
            <div class="d-flex align-items-md-center flex-md-row flex-sm-column">
                <div class="col-sm-12 col-md-6">
                    <div class="d-flex align-items-center mb-4">
                        <img class="mr-3"  src="@/assets/images/icons/event_seat.svg" width="20px"> <h3 class="m-0">Reporte de Ausentismos general</h3>
                    </div>
                    <p>Archivo plano que contiene el reporte total de Ausentismos en la compañia. <strong>Solo se permiten archivos .csv</strong></p>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="file-upload-img col-12">
                        <input
                        type="file"
                        id="fileDocuAbs"
                        @change="fileSelected('abs')"
                        accept=".csv"
                        required
                        />
                        <span>
                        <img class="col-12" src="@/assets/images/settler/uploadFile.jpg" />
                        </span>
                    </div>
                </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8 mx-auto mt-5 drop-container">
            <div class="d-flex align-items-md-center flex-md-row flex-sm-column">
                <div class="col-sm-12 col-md-6">
                    <div class="d-flex align-items-center mb-4">
                        <img class="mr-3"  src="@/assets/images/icons/history.svg" width="25px"> <h3 class="m-0">Historico laboral general</h3>
                    </div>
                    <p>Archivo plano que contiene toda el histórico laboral registrado de los empleados pertenecientes a la compañía y sus diferentes razones sociales</p>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="file-upload-img col-12">
                        <input
                        type="file"
                        id="fileHistory"
                        @change="fileSelected('history')"
                        accept=".xlsx"
                        required
                        />
                        <span>
                        <img class="col-12" src="@/assets/images/settler/uploadFile.jpg" />
                        </span>
                    </div>
                </div>
            </div>
          </div>
          <!-- Subir achivo CIE-10 -->
          <template v-if="can('18|19')">
            <div class="col-xs-12 col-md-8 mx-auto mt-5 drop-container">
              <div class="d-flex align-items-md-center flex-md-row flex-sm-column">
                <div class="col-sm-12 col-md-6">
                  <div class="d-flex align-items-center mb-4">
                    <img class="mr-3"  src="@/assets/images/icons/list_alt.svg" width="25px"> <h3 class="m-0">CIE-10</h3>
                  </div>
                  <p>Archivo plano que contiene toda la clasificación internacional de enfermedades y problemas relacionados con la salud.</p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="file-upload-img col-12">
                    <input
                        type="file"
                        id="fileCie10"
                        @change="fileSelected('cie10')"
                        accept=".xlsx"
                        required
                    />
                    <span>
                          <img class="col-12" src="@/assets/images/settler/uploadFile.jpg" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
      </div>
    </div>
     <!-- modal de carga -->
     <b-modal id="modal-upload" hide-footer centered no-close-on-backdrop>
            <div v-if="loading2" class="col-12 text-center">
                    <h1>Cargando..</h1>
                    <div v-if="loading2" id="loader2"></div>
             </div>
            <div v-else class="col-12 d-flex flex-column align-items-center modal-vp2 text-center">
                <img class="col-4 my-3" src="@/assets/images/icons/cloud_upload.svg" />
                <h1>El archivo de {{typeOfFile}} se cargará en segundo plano</h1>
                <h3 class="my-3">{{nameFile}}</h3>
                <p class="my-3">Si hay alguna novedad en el proceso, te estaremos informando vía email.</p>
                <button class="my-4 col-6 btn btn-success" @click="saveFileSelected" >Entendido</button>
            </div>
        </b-modal>

    <!-- 3 MODAL CREACIÓN LINEA DE NEGOCIO -- EXITOSO  -->
     <b-modal v-if="success_message" id="modal-success" hide-footer centered no-close-on-backdrop>
        <div class="col-12 d-flex flex-column align-items-center">
             <img class="centerImg1" src="@/assets/images/icons/check_circle_green.svg" width="20%">
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ success_message }}</p>
            <button class="mt-5 mb-5 col-6 btn btn-success" @click="$bvModal.hide('modal-success')">Entendido</button>
        </div>
    </b-modal>

    <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->
     <b-modal v-if="error.message || new_format_error.exist" id="modal-fail" hide-footer centered no-close-on-backdrop>
        <div class="col-12 d-flex flex-column align-items-center">
             <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%">
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
          <p class="pt-5">{{ error.message ? error.message : new_format_error.message }}</p>
            <button class="mt-5 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail')">Entendido</button>
        </div>
    </b-modal>
  </div>
  
  <!-- #page-onboarding -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";
import {path} from '@/services/health-tracker/employee/path'

export default {
    name: "novelties",
    components: {
    MainBarMenuV2,
    HeadingUser,
  },
  data: () => ({
    nameFile: "",
    typeOfFile:"",
    templateEmployee: `${process.env.VUE_APP_URL_API}${path?.templateEmployee}`,
  }),
  computed: {
    ...mapState("modOhAnalyst", [
        "loading",
        "loading2",
        "error",
        "message",
        'new_format_error'
      ]),
    checkEdit: function () {
        return this.nameLN === ''
    },
    /**
     * Verifica el mensaje de exito y lo retorna
     **/
    success_message () {
      const values = {
        'empleados': this.get_message_success_file_employee,
        'CIE-10': this.get_message_success_file_employee
      }
      if (values[this.typeOfFile]) {
        if (this.message) {
            return values[this.typeOfFile]
        }
      }
      return this.get_message_success_file_general
    },
    get_message_success_file_employee() {
      return this.message
    },
    get_message_success_file_general () {
      return this.message?.message ? this.message.message : this.message
    }
  },
  methods: {
    ...mapActions("modOhAnalyst",[
        "actSaveFileEmployeeHT",
        "actSaveFileAbs",
        "actUploadFileHistoryWorker",
        'act_upload_file_cie10'
    ]),
    fileSelected(x) {
      const options = {
        'employees': this.send_file_of_employee,
        'abs': this.send_file_of_abs,
        'history': this.send_file_of_history,
        'cie10': this.send_file_of_cie_10
      }
      if (options[x]) {
          options[x]()
          return this.$root.$emit('bv::show::modal','modal-upload')
      }
        /*let dato = ''
        switch (x) {
            case 'employees':
                  dato = document.querySelector("#fileDocuEmployees");
                  this.nameFile = dato.files[0].name;
                  this.typeOfFile = 'Empleados'
                break;
              case 'abs':
                  dato = document.querySelector("#fileDocuAbs");
                  this.nameFile = dato.files[0].name;
                  this.typeOfFile = 'Ausentismos'
                  break;
              case 'history':
                  dato = document.querySelector("#fileHistory");
                  this.nameFile = dato.files[0].name;
                  this.typeOfFile = 'Historico Laboral'
                  break;
        }
        this.$root.$emit('bv::show::modal','modal-upload')*/
  },
    send_file_of_employee () {
      this.nameFile = this.get_name_file_to_selector(this.get_query_selector('fileDocuEmployees'))
      this.typeOfFile = 'empleados'
    },
    send_file_of_abs () {
      this.nameFile = this.get_name_file_to_selector(this.get_query_selector('fileDocuAbs'))
      this.typeOfFile = 'ausentismos'
    },
    send_file_of_history () {
      this.nameFile = this.get_name_file_to_selector(this.get_query_selector('fileHistory'))
      this.typeOfFile = 'historico laboral'
    },
    send_file_of_cie_10 () {
      this.nameFile = this.get_name_file_to_selector(this.get_query_selector('fileCie10'))
      this.typeOfFile = 'CIE-10'
    },
    get_query_selector (id = '') {
      return document.querySelector(`#${id}`)
    },
    get_name_file_to_selector(selector) {
       return selector.files[0].name
    },
    get_first_file_to_selector(selector) {
      return selector.files[0]
    },
    saveFileSelected() {
        const options = {
          'empleados': this.save_employee_file,
          'ausentismos': this.save_abs_file,
          'historico laboral': this.save_history_file,
          'CIE-10': this.save_cie10_file
        }
        if(options[this.typeOfFile]) {
          return options[this.typeOfFile]()
        }
        /*var formData = new FormData();
        let fileSelected = ''
        switch (this.typeOfFile) {
            case 'Empleados':
                fileSelected = document.querySelector("#fileDocuEmployees");
                formData.append("file", fileSelected.files[0]);
                await this.actSaveFileEmployeeHT(formData).then(() => {
                        this.checkUpload()
                })
                break;
            case 'Ausentismos':
                fileSelected = document.querySelector("#fileDocuAbs");
                formData.append("file", fileSelected.files[0]);
                await this.actSaveFileAbs(formData).then(() => {
                        this.checkUpload()
                })
                break;
            case 'Historico Laboral':
                fileSelected = document.querySelector("#fileHistory");
                formData.append("file", fileSelected.files[0]);
                await this.actUploadFileHistoryWorker(formData).then(() => {
                        this.checkUpload()
                })
                break;

            default:
                break;
        }*/

    },
    async save_employee_file () {
      let form_data = new FormData()
      form_data.append('file', this.get_first_file_to_selector(this.get_query_selector('fileDocuEmployees')))
      await this.actSaveFileEmployeeHT(form_data)
      this.checkUpload()
      const idFile = document.querySelector('#fileDocuEmployees');
      idFile.value = '';
    },
    async save_abs_file () {
      let form_data = new FormData()
      form_data.append('file', this.get_first_file_to_selector(this.get_query_selector('fileDocuAbs')))
      await this.actSaveFileAbs(form_data)
      this.checkUpload()
      const idFile = document.querySelector('#fileDocuAbs');
      idFile.value = '';
    },
    async save_history_file () {
      let form_data = new FormData()
      form_data.append('file', this.get_first_file_to_selector(this.get_query_selector('fileHistory')))
      await this.actUploadFileHistoryWorker(form_data).then(() => { this.checkUpload() })
    },
    async save_cie10_file () {
      let form_data = new FormData()
      form_data.append('file', this.get_first_file_to_selector(this.get_query_selector('fileCie10')))
      await this.act_upload_file_cie10(form_data)
      this.checkUpload()
    },
    checkUpload(){
      this.$root.$emit('bv::hide::modal','modal-upload')
      if (this.error.message || this.new_format_error.exist) {
        this.$root.$emit('bv::show::modal','modal-fail')
      } else {
        this.$root.$emit('bv::show::modal','modal-success')
      }
      this.nameFile = ''
    }
  },
}
</script>

<style lang="scss">
#uploadFiles{
    .drop-container{
        padding: 30px 15px;
        border: #E9ECEE solid 1px;
        border-radius: 15px;
        h3{
        color: #1C3A4E;
        font-size: 20px;
        font-weight: 600;
        }
    }
    .file-upload-img {
        height: 200px;
        border-radius: 15px;
        text-align: center;
        display: flex;
        align-items: center;
        border: 2px #0C9E42 dashed;
        margin-bottom: 15px;
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
        
            input[type="file"] {
            opacity: 0;
            filter: alpha(opacity=0);
            display: block;
            position: absolute;
            cursor: pointer;
            z-index: 1;
            height: 150px;
            }

            span p{
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
    }
}
#modal-upload {
    #loader2 {
            margin: 40px auto;
            z-index: 1;
            width: 100px;
            height: 100px;
            border: 15px solid #f3f3f3;
            border-radius: 50%;
            border-top: 15px solid #8f8f8f;
            -webkit-animation: spin 2s linear infinite;
            animation: spin 2s linear infinite;
        }
}
.modal-content .modal-vp2{
        color: dimgrey;
    }

</style>